import { DataTemplate } from "../schemas/request-template";

export abstract class Serializable {

    abstract serialize(endpoint: string): object;

    abstract deserialize(endpoint: string, template: DataTemplate): void;

}